import React, { Component, useState, Fragment } from "react";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import { Accordion, Card } from "react-bootstrap";
import CheckBoxComponent from '../CheckBox';
import SpanMoreTabDown from "../../images/chevron-down-small.svg";
import SpanMoreTabTop from "../../images/chevron-top.svg";

const imgScale = {
    width: "24px",
    height: "24px"
  };
const Icon = props => (
    <img className={props.className} src={props.src} {...imgScale} />
);

function CustomToggle({ init, children, eventKey, text }) {
    const decoratedOnClick = useAccordionToggle(eventKey);
    const [toggle, setToggle] = useState(true);
  
    const onToggle = e => {
      e.stopPropagation();
      setToggle(!toggle);
      decoratedOnClick();
    };

    return (
        <div className="d-flex align-item-center accordion-header" onClick={e => onToggle(e)}>
            <p className="header-accordion-text">รูปแบบรับกรมธรรม์</p>
            <Icon className="ml-auto" src={toggle ? SpanMoreTabTop : SpanMoreTabDown} />
        </div>
    );
}

export default class CheckBoxReceived extends Component {
    render() {

        const { recieveEmail, recievePost, onChangeModel } = this.props;

        return(
            <Accordion defaultActiveKey={"0"} className="accordion-wrapper">
                <Card className="accordion-item" key={"0"}>
                <CustomToggle text="รูปแบบรับกรมธรรม์" eventKey={"0"} />
                {/* <Accordion.Toggle as={Card.Header} eventKey={"0"}>
                    <div className="d-flex align-item-center">
                    <p className="header-accordion-text">รูปแบบรับกรมธรรม์</p>
                    <Icon className="ml-auto" src={ChevonDown} />
                    </div>
                </Accordion.Toggle> */}
                <Accordion.Collapse eventKey={"0"}>
                    <Card.Body className="pt-1">
                        <CheckBoxComponent 
                            text="รับกรมธรรม์ทางอีเมล"
                            checked={recieveEmail}
                            onChange={(checked) =>
                            onChangeModel({ name: "recieveEmail", value: checked })
                            }
                        />
                        <CheckBoxComponent 
                            text="รับกรมธรรม์ทางไปรษณีย์"
                            checked={recievePost}
                            onChange={(checked) =>
                            onChangeModel({ name: "recievePost", value: checked })
                            }
                        />
                    </Card.Body>
                </Accordion.Collapse>
                </Card>
            </Accordion>
        )
    }
}